module.exports = __webpack_public_path__ + "static/media/p2_15.b769e88b.png";